import { CloseOutlined } from "@ant-design/icons";
import { Button, Checkbox, ConfigProvider, DatePicker, Form, Input, Modal, Select, TimePicker } from "antd";

import viVN from 'antd/locale/vi_VN';

import { FormProps } from "antd/lib";
import dayjs from "dayjs";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { getInfoCarCustomer } from "../../../../../../api/car/carApi";
import { editRepairAppointment, InfoRepairAppointment } from "../../../../../../api/Customer_V2/customerApi_V2";
import { getSLCarsByCarLineIdAndCategoryCarId } from "../../../../../../api/selectOption/selectOptionsApi";
import { getSLProfitCenterName, getSLVehicleEngineNos, ISelectOption } from "../../../../../../api/selectOptions/selectOptionsApi";
import useDebounce from "../../../../../../hook/useDebounce";
import useLoading from "../../../../../../hook/useLoading";
import useThrottle from "../../../../../../hook/useThrottle";
import useToast from "../../../../../../hook/useToast";
import { dataInteractionCategory, dataInteractionCategory_V2 } from "../../../../../../services/data";
import { selectorInfoUser } from "../../../../../../store/slices/infoUserSlice";
import { selectorUnitByUserPermission } from "../../../../../../store/slices/UnitByUserPermission";
import { convertToAntdOptions, fommatSelectOption, fommatSelectOptionToUpperCase, fommatSelectOptionUnitByUser, mapDocCode } from "../../../../../../until";
import '../../../../styles.scss';

const { TextArea } = Input;

interface ModalProps {
    isOpen: boolean
    idCustomer?: number
    infoRepairAppointment?: InfoRepairAppointment
    resultFormSubmit?: (iSsuccess: boolean, message?: string) => void
    closeModal: (isOpen: boolean) => void
}
const ModalSalesAndServiceScheduleARepairUpdate: React.FC<ModalProps> = ({
    isOpen, idCustomer, infoRepairAppointment,
    resultFormSubmit, closeModal
}) => {

    const pushToast = useToast()
    const pushLoading = useLoading()
    const { id, username, unit } = useSelector(selectorInfoUser)
    const unitByUserPermissionSlice = useSelector(selectorUnitByUserPermission)

    const [form] = Form.useForm();

    const isProgrammaticCarLineSet = React.useRef(true);
    const isProgrammaticPlate = React.useRef(true);
    const isProgrammaticChassisNo = React.useRef(true);
    const isProgrammaticArrive = React.useRef(true);

    const registrationDate = Form.useWatch("registrationDate", form); // ngày ghi nhận

    const vehicleId = Form.useWatch("vehicleId", form); // tên xe

    // const numberPlateId = Form.useWatch("numberPlateId", form); // biển số
    const chassisNo = Form.useWatch("chassisNo", form); // số khung
    const engineNo = Form.useWatch("engineNo", form); // số máy

    const tentativeRegistrationDate = Form.useWatch("tentativeRegistrationDate", form); // Ngày hẹn sửa chữa
    const vehicleBookingEffectiveGetDate = Form.useWatch("vehicleBookingEffectiveGetDate", form); // Ngày bắt đầu sửa chữa

    const isArrive = Form.useWatch("isArrive", form); // Khách đến xưởng


    const [sLProfitCenterName, setSLProfitCenterName] = useState<ISelectOption[]>([])
    const [sLCarId, setSLCarId] = useState<any[]>([])
    const [sLNumberPlateId, setSLNumberPlateId] = useState<ISelectOption[]>([])
    const [sLChassisNo, setSLChassisNo] = useState<ISelectOption[]>([])
    const [sLEngineNo, setSLEngineNo] = useState<ISelectOption[]>([])

    const [sLAdminId, setSLAdminId] = useState<ISelectOption[]>([{ value: id, label: username }])
    const [sLBranchId, setSLBranchId] = useState<ISelectOption[]>([])
    const [searchCar, setSearchCar] = useState<string>('')


    const [carId, setCarId] = useState<number>()
    const [plateNumberId, setPlateNumberId] = useState<number>()

    //#region gọi api SL OP
    // Loại hình dịch vụ
    const gSLProfitCenterName = async () => {
        if (!idCustomer) return
        const result = await getSLProfitCenterName(

        )
        if (result?.status) {
            setSLProfitCenterName(fommatSelectOption(result.data))
        }
    }

    // tên xe
    const gSLCarId = useDebounce(async () => {
        if (!idCustomer) return
        const result = await getSLCarsByCarLineIdAndCategoryCarId(
            idCustomer, undefined, undefined, searchCar
        )
        if (result?.status) {
            setSLCarId(convertToAntdOptions(result.data))
        }
    }, 1000)

    const gInfoCarCustomer = useDebounce(async () => {
        if (!idCustomer || !vehicleId) return
        const result = await getInfoCarCustomer(
            vehicleId, idCustomer
        )
        if (result?.status) {
            const { plateNumber, plateNumberId, vehicleChassisNo } = result.data
            setSLChassisNo(fommatSelectOptionToUpperCase(vehicleChassisNo))
            setPlateNumberId(plateNumberId)
            form.setFieldValue("numberPlateId", plateNumber);
            if (vehicleChassisNo.length === 1)
                form.setFieldValue("chassisNo", vehicleChassisNo[0].id);
        }
    }, 1000)

    // số máy
    const gSLEngineNo = async () => {
        if (!idCustomer) return
        if (!vehicleId) {
            setSLEngineNo([])
            return
        }
        const result = await getSLVehicleEngineNos(
            idCustomer, vehicleId,
        )
        if (result?.status) {
            setSLEngineNo(fommatSelectOptionToUpperCase(result.data))

            if (result.data.length === 1) {
                const { id } = result.data[0]
                form.setFieldValue("engineNo", id); // Số máy
            }
        }
    }

    //dơn vị
    const gSLBranchId = async () => {
        setSLBranchId(fommatSelectOptionUnitByUser(unitByUserPermissionSlice))
    }
    //#endregion

    const submitForm = () => {
        if (form) {
            form.submit();
        }
    };

    const onFinish: FormProps["onFinish"] = useThrottle(async (values: any) => {

        if (!idCustomer) return
        pushLoading(true)
        const {
            vehicleBookingDocCode, registrationDate, tentativeRegistrationDate,
            registrationTime,
            contactType, profitCenterName, vehicleId,
            chassisNo, engineNo, adminId, cabinNo,
            vehicleBookingEffectiveGetDate, vehicleBookingEffectiveGetTime, branchId, routeId,
            tentativeCustomerRequest, isArrive, dungHen, saiHen
        } = values

        const registrationDateTmp = registrationDate ? registrationDate?.format('YYYY/MM/DD') : undefined
        const tentativeRegistrationDateTmp = tentativeRegistrationDate ? tentativeRegistrationDate?.format('YYYY/MM/DD') : undefined
        const registrationTimeTmp = registrationTime ? registrationTime?.format('HH:mm') : undefined
        const vehicleBookingEffectiveGetDateTmp = vehicleBookingEffectiveGetDate ? vehicleBookingEffectiveGetDate?.format('YYYY/MM/DD') : undefined
        const vehicleBookingEffectiveGetTimeTmp = vehicleBookingEffectiveGetTime ? vehicleBookingEffectiveGetTime?.format('HH:mm') : undefined


        const result = await editRepairAppointment(
            infoRepairAppointment?.id || 0, idCustomer, vehicleBookingDocCode, registrationDateTmp,
            tentativeRegistrationDateTmp, registrationTimeTmp, contactType, profitCenterName,
            carId, vehicleId, plateNumberId, chassisNo, engineNo,
            adminId, cabinNo, vehicleBookingEffectiveGetDateTmp, vehicleBookingEffectiveGetTimeTmp,
            branchId, routeId, tentativeCustomerRequest, isArrive,
            dungHen, saiHen
        )
        if (result?.status) {
            resultFormSubmit?.(true, result?.message)
        } else {
            resultFormSubmit?.(false, result?.message)
        }
        pushLoading(false)

    }, 2000)

    useEffect(() => {
        if (isOpen)
            gSLCarId()
    }, [searchCar])

    //#region Thay đổi form rs 
    useEffect(() => {
        // if (!isOpen) return

        // gSLNumberPlateId()
        // if (isProgrammaticCarLineSet.current) {
        //     isProgrammaticCarLineSet.current = false;
        //     return;
        // }
        // if (isOpen) {
        //     form.setFieldValue("numberPlateId", undefined); //rs  biển số xe
        //     form.setFieldValue("chassisNo", undefined); //rs Số khung (VIN)
        //     form.setFieldValue("engineNo", undefined); //rs bSố máy
        // }

        if (!isOpen) return
        if (vehicleId) {
            gInfoCarCustomer()
        }

        if (isProgrammaticCarLineSet.current) {
            isProgrammaticCarLineSet.current = false;
            return;
        }

        if (!vehicleId) {
            form.setFieldsValue({
                "numberPlateId": undefined,
                "chassisNo": undefined,
                "engineNo": undefined
            })

            setSLChassisNo([])
            setSLEngineNo([])
        }

        if (isOpen) {
            form.setFieldValue("numberPlateId", undefined); //rs  biển số xe
            form.setFieldValue("chassisNo", undefined); //rs Số khung (VIN)
            form.setFieldValue("engineNo", undefined); //rs bSố máy
        }
    }, [vehicleId]); //tên xe thay đổi


    useEffect(() => {
        if (!isOpen) return

        gSLEngineNo()
        if (isProgrammaticChassisNo.current) {
            isProgrammaticChassisNo.current = false;
            return;
        }
        if (isOpen) {
            form.setFieldValue("engineNo", undefined); //rs bSố máy
        }
    }, [chassisNo]); //Số khung (VIN)

    useEffect(() => {
        if (!isOpen) return

        if (isOpen) {
            if (vehicleBookingEffectiveGetDate)
                form.setFieldValue("isArrive", true); //rs tự check Khách hàng đã đến xưởng khi vehicleBookingEffectiveGetDate
        }
    }, [vehicleBookingEffectiveGetDate]);

    useEffect(() => {
        if (!isOpen) return
        if (isProgrammaticArrive.current) {
            isProgrammaticArrive.current = false;
            return;
        }
        if (isOpen) {
            form.setFieldValue("dungHen", false); //rs dungHen
            form.setFieldValue("saiHen", false); //rs saiHen
        }
    }, [isArrive]);

    //#endregion


    useEffect(() => {
        if (isOpen) {
            if (!sLProfitCenterName.length)
                gSLProfitCenterName()
            if (!sLCarId.length)
                gSLCarId()
            if (!sLBranchId.length)
                gSLBranchId()

            form.setFieldsValue({
                adminId: id,
                branchId: unit,
                docDate: dayjs(),
                tentativeRegistrationDate: dayjs(),
                registrationTime: dayjs().startOf("minute"),
            });
        } else {
            form.resetFields()
        }

    }, [isOpen])


    useEffect(() => {
        if (!isOpen || !infoRepairAppointment) return;
        isProgrammaticCarLineSet.current = true;
        isProgrammaticPlate.current = true;
        isProgrammaticChassisNo.current = true;
        isProgrammaticArrive.current = true;

        const registrationDateTmp = infoRepairAppointment.registrationDate
            ? dayjs(infoRepairAppointment.registrationDate, 'DD/MM/YYYY')
            : undefined
        const tentativeRegistrationDateTmp = infoRepairAppointment.tentativeRegistrationDate ? dayjs(infoRepairAppointment.tentativeRegistrationDate, 'DD/MM/YYYY') : dayjs()
        const registrationTimeTmp = infoRepairAppointment.registrationTime
            ? dayjs(infoRepairAppointment.registrationTime, 'HH:mm')
            : dayjs().startOf('minute')
        const vehicleBookingEffectiveGetDateTmp = infoRepairAppointment.vehicleBookingEffectiveGetDate
            ? dayjs(infoRepairAppointment.vehicleBookingEffectiveGetDate, 'DD/MM/YYYY')
            : undefined
        const vehicleBookingEffectiveGetTimeTmp = infoRepairAppointment.vehicleBookingEffectiveGetTime
            ? dayjs(infoRepairAppointment.vehicleBookingEffectiveGetTime, 'HH:mm')
            : undefined

        form.setFieldsValue({
            registrationDate: registrationDateTmp,
            tentativeRegistrationDate: tentativeRegistrationDateTmp,

            registrationTime: registrationTimeTmp,

            vehicleBookingEffectiveGetDate: vehicleBookingEffectiveGetDateTmp,

            vehicleBookingEffectiveGetTime: vehicleBookingEffectiveGetTimeTmp,

            vehicleBookingDocCode: mapDocCode(infoRepairAppointment.vehicleBookingDocCode),
            contactType: infoRepairAppointment.contactType,

            profitCenterName: infoRepairAppointment.profitCenterName,

            carId: infoRepairAppointment.carId,
            vehicleId: infoRepairAppointment.vehicleId,
            numberPlateId: infoRepairAppointment.plateNumberId,
            chassisNo: infoRepairAppointment.chassisNo,
            engineNo: infoRepairAppointment.engineNo,
            cabinNo: infoRepairAppointment.cabinNo,


            adminId: id,
            branchId: infoRepairAppointment.branchId,
            routeId: infoRepairAppointment.routeId,

            tentativeCustomerRequest: infoRepairAppointment.tentativeCustomerRequest,
            isArrive: infoRepairAppointment.isArrive,
            dungHen: infoRepairAppointment.dungHen,
            saiHen: infoRepairAppointment.saiHen,
        });
    }, [isOpen, infoRepairAppointment]);

    return (
        <Form
            form={form}
            layout="vertical"
            className=" "
            onFinish={onFinish}
        >
            <ConfigProvider locale={viVN}>
                <Modal
                    title={<div className="bg-FCFCFD d-flex justify-betweeen align-center pb-4  w-full border-b-F0F0F0 rounded-2 overflow-hidden">
                        <span className="text-base text-344054 fw-500 font-medium">Chỉnh sửa đặt lịch hẹn sửa chữa</span>
                        <CloseOutlined className="text-base text-8B8B8B" onClick={() => closeModal(false)} />
                    </div>}
                    open={isOpen}
                    onCancel={() => closeModal(false)}
                    centered
                    className="custom-modal-ant-history"
                    destroyOnClose
                    closeIcon={false}
                    footer={<div className="bg-FCFCFD d-flex justify-betweeen align-center pt-2  w-full border-t-F0F0F0">
                        <div className="custom-page-css w-full flex justify-end gap-2 mt-4">
                            <Button onClick={() => closeModal(false)}>Huỷ</Button>
                            <Button
                                type="primary"
                                onClick={submitForm}
                            >Lưu</Button>
                        </div>
                    </div>}
                >
                    <div className="custom-modal-ant-history-child custom-page-css flex flex-col max-h-65vh overflow-y-scroll gap-2 py-2">
                        <span className="text-base text-344054 fw-500 font-medium">Thông tin chung</span>

                        <div className="grid grid-cols-2 gap-4">
                            <Form.Item

                                layout="vertical"
                                label={<span>
                                    Loại tương tác <span className="text-FF1D1D">*</span>:
                                </span>}
                                name="vehicleBookingDocCode"
                                rules={[
                                    { required: true, message: "Vui lòng loại tương tác" },
                                ]}
                            >
                                <Select
                                    className="custom-page-css border rounded"
                                    placeholder="Loại tương tác"
                                    disabled
                                    options={dataInteractionCategory_V2}
                                />
                            </Form.Item>

                            <Form.Item

                                layout="vertical"
                                label="Phân loại liên hệ:"
                                name="contactType"
                            >
                                <Select
                                    className="custom-page-css border rounded"
                                    placeholder="Phân loại liên hệ"
                                    options={dataInteractionCategory}
                                />
                            </Form.Item>
                        </div>
                        {/* Row 1 */}
                        <div className="grid grid-cols-2 gap-4">
                            <Form.Item

                                layout="vertical"
                                label={
                                    <span>Ngày ghi nhận <span className="text-FF1D1D">*</span>:</span>
                                }
                                name="registrationDate"
                                rules={[
                                    { required: true, message: "Vui lòng ngày ghi nhận" },
                                ]}
                            >
                                <DatePicker className="w-full custom-input-date" format="DD/MM/YYYY" />
                            </Form.Item>

                            <Form.Item

                                layout="vertical"
                                label="Tên Hợp đồng kinh doanh:"
                                name="profitCenterName"
                            >
                                <Select
                                    className="custom-page-css border rounded"
                                    placeholder="Tên Hợp đồng kinh doanh"
                                    options={sLProfitCenterName}
                                />
                            </Form.Item>
                        </div>

                        <span className="text-base text-344054 fw-500 font-medium pt-2">Thông tin xe</span>
                        {/* Row 3 */}
                        <div className="grid grid-cols-2 gap-4">
                            <Form.Item

                                layout="vertical" name='carId' hidden></Form.Item>


                            <Form.Item
                                layout="vertical"
                                label={<span>
                                    Tên xe <span className="text-FF1D1D">*</span>:
                                </span>}
                                name="vehicleId"
                                rules={[
                                    { required: true, message: "Vui lòng chọn tên xe" },
                                ]}
                            >
                                <Select
                                    className="custom-page-css border rounded"
                                    placeholder="Tên xe"
                                    showSearch
                                    searchValue={searchCar}
                                    onSearch={(e) => setSearchCar(e)}
                                    filterOption={false}
                                    allowClear
                                    options={sLCarId}
                                    onChange={(value, option: any) => {
                                        setCarId(option?.carId)
                                    }}
                                />

                            </Form.Item>
                            <Form.Item
                                label="Biển số xe:"
                                name="numberPlateId"
                                layout="vertical"
                            >
                                <Input
                                    className="custom-page-css border rounded"
                                    placeholder="Biển số xe"
                                    disabled
                                />
                            </Form.Item>
                        </div>
                        <div className="grid grid-cols-2 gap-4">
                            <Form.Item

                                layout="vertical"
                                label="Số khung:"
                                name="chassisNo"
                            >
                                <Select
                                    className="custom-page-css border rounded"
                                    placeholder="Số khung"
                                    disabled={!vehicleId}
                                    options={sLChassisNo}
                                />
                            </Form.Item>

                            <Form.Item

                                layout="vertical"
                                label="Số máy:"
                                name="engineNo"
                            >
                                <Select
                                    className="custom-page-css border rounded"
                                    placeholder="Số máy"
                                    disabled={!chassisNo}
                                    options={sLEngineNo}
                                />
                            </Form.Item>
                        </div>
                        <span className="text-base text-344054 fw-500 font-medium pt-2">Thông tin lịch hẹn</span>

                        {/* Row 4 */}
                        <div className="grid grid-cols-2 gap-4">
                            <Form.Item

                                layout="vertical"
                                label="Nhân viên tiếp nhận:"
                                name="adminId"
                            >
                                <Select
                                    className="custom-page-css border rounded"
                                    placeholder="Nhân viên tiếp nhận"
                                    disabled
                                    options={sLAdminId}
                                />
                            </Form.Item>
                            <Form.Item

                                layout="vertical"
                                label="Khoang:"
                                name="cabinNo"
                            >
                                <Input
                                    className="custom-page-css border rounded custom-input-css"
                                    placeholder="Khoang" />
                            </Form.Item>
                        </div>
                        <div className="custom-page-css grid grid-cols-2 gap-6">
                            {/* Ngày hẹn đến sửa */}
                            <div className="custom-page-css flex flex-col gap-2">
                                <label className="text-sm text-gray-800">
                                    Ngày hẹn đến sửa <span className="text-FF1D1D">*</span>:
                                </label>

                                <div className="custom-page-css grid grid-cols-2 gap-3">
                                    <Form.Item

                                        layout="vertical"
                                        name="tentativeRegistrationDate"
                                        rules={[
                                            { required: true, message: "Vui lòng chọn ngày hẹn đến sửa" },
                                        ]}
                                    >
                                        <DatePicker
                                            placeholder="Chọn ngày"
                                            className="w-full   custom-input-date"
                                            format="DD/MM/YYYY"
                                        />
                                    </Form.Item>

                                    <Form.Item

                                        layout="vertical"
                                        name="registrationTime"
                                        rules={[
                                            { required: true, message: "Vui lòng chọn ngày hẹn đến sửa" },
                                        ]}
                                    >
                                        <TimePicker
                                            placeholder="Chọn giờ"
                                            className="w-full custom-input-date"
                                            format="HH:mm"
                                            disabled={!tentativeRegistrationDate}
                                        />
                                    </Form.Item>
                                </div>
                            </div>

                            {/* Ngày bắt đầu sửa chữa */}
                            <div className="custom-page-css flex flex-col gap-2">
                                <label className="text-sm text-gray-800">
                                    Ngày bắt đầu sửa chữa:
                                </label>

                                <div className="custom-page-css grid grid-cols-2 gap-3">
                                    <Form.Item

                                        layout="vertical"
                                        name="vehicleBookingEffectiveGetDate"
                                    >
                                        <DatePicker
                                            placeholder="Chọn ngày"
                                            className="w-full custom-input-date"
                                            format="DD/MM/YYYY"
                                        />
                                    </Form.Item>


                                    <Form.Item

                                        layout="vertical"
                                        name="vehicleBookingEffectiveGetTime"
                                        dependencies={[
                                            "vehicleBookingEffectiveGetDate",
                                            "tentativeRegistrationDate",
                                            "registrationTime",
                                        ]}
                                        rules={[
                                            ({ getFieldValue }) => ({
                                                validator(_, value) {
                                                    const startDate =
                                                        getFieldValue(
                                                            "vehicleBookingEffectiveGetDate"
                                                        );
                                                    const tentativeDate =
                                                        getFieldValue(
                                                            "tentativeRegistrationDate"
                                                        );
                                                    const tentativeTime =
                                                        getFieldValue("registrationTime");

                                                    // TH1: có ngày bắt đầu sửa → giờ bắt buộc
                                                    if (startDate && !value) {
                                                        return Promise.reject(
                                                            new Error(
                                                                "Vui lòng chọn giờ bắt đầu sửa chữa"
                                                            )
                                                        );
                                                    }

                                                    // TH2: so sánh datetime
                                                    if (
                                                        startDate &&
                                                        value &&
                                                        tentativeDate &&
                                                        tentativeTime
                                                    ) {
                                                        const startDateTime = startDate
                                                            .hour(value.hour())
                                                            .minute(value.minute());

                                                        const tentativeDateTime = tentativeDate
                                                            .hour(tentativeTime.hour())
                                                            .minute(tentativeTime.minute());

                                                        if (
                                                            startDateTime.isBefore(
                                                                tentativeDateTime
                                                            )
                                                        ) {
                                                            return Promise.reject(
                                                                new Error(
                                                                    "Ngày bắt đầu sửa chữa phải lớn hơn hoặc bằng ngày hẹn đến sửa"
                                                                )
                                                            );
                                                        }
                                                    }

                                                    return Promise.resolve();
                                                },
                                            }),
                                        ]}
                                    >
                                        <TimePicker
                                            placeholder="Chọn giờ"
                                            className="w-full custom-input-date"
                                            format="HH:mm"
                                            disabled={!vehicleBookingEffectiveGetDate}
                                        />
                                    </Form.Item>
                                </div>
                            </div>
                        </div>

                        <div className="grid grid-cols-2 gap-4">
                            <Form.Item

                                layout="vertical"
                                label="Đơn vị:"
                                name="branchId"
                            >
                                <Select
                                    className="custom-page-css border rounded"
                                    placeholder="Đơn vị"
                                    options={sLBranchId}
                                />
                            </Form.Item>
                            <Form.Item

                                layout="vertical"
                                label="Điểm bán hàng:"
                                name="routeId"
                            >
                                <Select
                                    className="custom-page-css border rounded"
                                    placeholder="Điểm bán hàng"
                                    options={sLBranchId}
                                />
                            </Form.Item>
                        </div>

                        <Form.Item

                            layout="vertical"
                            label="Yêu cầu khách hàng:"
                            name="tentativeCustomerRequest"
                        >
                            <TextArea
                                rows={4}
                                placeholder="Nhập yêu cầu khách hàng"
                            />
                        </Form.Item>

                        <Form.Item

                            name="isArrive"
                            valuePropName="checked"
                        >
                            <Checkbox
                            >Khách hàng đến xưởng
                            </Checkbox>
                        </Form.Item>

                        <Form.Item
                            name="dungHen"
                            valuePropName="checked"
                            className="custom-checkbox-to-radio"
                        >
                            <Checkbox
                                disabled={!isArrive}
                                onChange={(e) => {
                                    if (e.target.checked) {
                                        form.setFieldValue("saiHen", false);
                                    }
                                }}
                            >Đúng hẹn
                            </Checkbox>
                        </Form.Item>
                        <Form.Item
                            name="saiHen"
                            valuePropName="checked"
                            className="custom-checkbox-to-radio"
                        >
                            <Checkbox
                                disabled={!isArrive}
                                onChange={(e) => {
                                    if (e.target.checked) {
                                        form.setFieldValue("dungHen", false);
                                    }
                                }}
                            >Sai hẹn
                            </Checkbox>
                        </Form.Item>
                    </div>
                </Modal>
            </ConfigProvider>
        </Form >
    )
}
export default ModalSalesAndServiceScheduleARepairUpdate
